import React from 'react'
import * as Icon from 'react-feather'

import BreadcrumbHeader from '~/components/BreadcrumbHeader'
import { Header, ButtonTemplate } from './styles'
import { FormattedMessage } from 'react-intl'
import QuestionListing from '~/components/QuestionListing'
import { SearchParamsHandlerProvider } from '~/contexts/FilterContext'
import { NumberParam, StringParam, withDefault } from 'use-query-params'
import { useSelector } from 'react-redux'
import { Show } from '~/components/commons'
import { CLIENT_ADMIN } from '~/constants/roles'

export const PageContext = React.createContext({})

const QuestionsHeaderMenu = () => {
  const user = useSelector(state => state.user.profile)

  return (
    <div className="d-flex align-items-center justify-content-center mb-2 mb-sm-0">
      <Show condition={Boolean(user?.role >= CLIENT_ADMIN)}>
        <ButtonTemplate to="/templates/questions" className="ml-2">
          <Icon.FileText height={14} className="d-none d-md-block" />
          <FormattedMessage id="Template Gallery" />
        </ButtonTemplate>
      </Show>
    </div>
  )
}

const Questions = () => {
  const arrayParam = withDefault(
    {
      encode: array => array,
      decode: array => array?.split(','),
    },
    []
  )
  return (
    <>
      <Header>
        <BreadcrumbHeader
          styles={{
            height: '49px',
          }}
          path={[
            { name: 'Locations', path: '/' },
            { name: 'Reply Questions', path: 'questions' },
          ]}
        >
          <QuestionsHeaderMenu />
        </BreadcrumbHeader>
      </Header>
      <SearchParamsHandlerProvider
        queryParams={{
          states: withDefault(arrayParam, []),
          cities: withDefault(arrayParam, []),
          areas: withDefault(arrayParam, []),
          labels: withDefault(arrayParam, []),
          locations: withDefault(arrayParam, []),
          page: withDefault(NumberParam, 1),
          limit: withDefault(NumberParam, 10),
          search: StringParam,
          orderBy: StringParam,
        }}
      >
        <QuestionListing />
      </SearchParamsHandlerProvider>
    </>
  )
}

export default Questions
